import { toCamelCase } from '@cli-utils/text.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'
import { renderNavigationBarrelImportsTemplate } from '@next-adapter/templates/renderers/snapshots/barrels/render-navigation-barrel.js'

export function renderNavigationBarrel(navExtractNames: string[], namespaceValue: string): string {
  const namespace = resolveAdminNamespace(namespaceValue)
  const importLines = navExtractNames.map(
    (name) => `import { ${toCamelCase(name)}Nav } from './navigation/${name}'`
  )
  const spreadLines = navExtractNames.map((name) => `  ...${toCamelCase(name)}Nav`)
  const extractImports = importLines.length > 0 ? `\n${importLines.join('\n')}` : ''

  return renderNavigationBarrelImportsTemplate({
    namespacePascal: String(namespace.pascal),
    namespaceAlias: String(namespace.alias),
    extractImports: String(extractImports),
    namespaceRoutePath: String(namespace.routePath),
    spreadLinesContent: String(spreadLines.length > 0 ? `,\n${spreadLines.join(',\n')}` : ''),
    namespaceCamel: String(namespace.camel)
  })
}
